import React from 'react'
import { object } from 'prop-types'
import { Tooltip, OverlayTrigger } from 'react-bootstrap' 

const CampaignStatus = ({ campaign }) => {
  var videosPlaying = 0
  var videosPaused = 0
  var ballClass = 'danger'
  campaign.videos.forEach((video) => {
    if (video.status !== undefined) {
      switch (video.status.name) {
        case 'playing':
          videosPlaying += 1
          break
        case 'paused':
          videosPaused += 1
          break
        default:
          videosPaused += 1
      }
    } else {
      videosPaused += 1
    }
  })
  if (videosPlaying > 0 && videosPaused === 0) {
    ballClass = 'success'
  } else if (videosPlaying > 0 && videosPaused > 0) {
    ballClass = 'warning'
  }
  const tooltip = (
    <Tooltip id={campaign.id}>
      {makeTooltipText(videosPlaying, videosPaused)}
    </Tooltip>
  )
  return (
    <OverlayTrigger placement='top' overlay={tooltip}>
      <span
        className={`bg-${ballClass} statusBall`}
      />
    </OverlayTrigger>
  )
}

function makeTooltipText (videosPlaying, videosPaused) {
  var text = ''
  if (videosPlaying > 0) {
    if (videosPlaying === 1) {
      text += `${videosPlaying} video ativo.`
    } else {
      text += `${videosPlaying} videos ativos.`
    }
  }
  if (videosPaused > 0) {
    if (videosPaused === 1) {
      text += ` ${videosPaused} video pausado.`
    } else {
      text += ` ${videosPaused} videos pausados.`
    }
  }
  return text
}

CampaignStatus.propTypes = {
  campaign: object
}

export default CampaignStatus



// WEBPACK FOOTER //
// ./src/components/CampaignStatus.js